import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { Line } from "@vds/lines";
import { ListGroup, ListGroupItem, ListGroupItemTitle, ListGroupItemSubtitle } from "@vds/lists";

import { fetchExtendedPreview } from "./actions";
import { setA11yContent } from "../NavigationHelper/actions";
import { selectDevice, setBreadCrumbListInRedux } from "../DownloadAndDelete/actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { media } from "utils/style";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import { fetchPageContent } from "../DownloadAndDelete/actions";
import { customRole as setCustomRole } from "utils/customRole";

import {Tilelet, TileletGroup} from "@vds/tiles"
import DownloadAndDelete from "../DownloadAndDelete/DownloadAndDelete";
import { LandingPageAccordion as Accordion } from "common-components";
import { ButtonWithArrowNew } from "common-components/Buttons";
import { Tile as CommonTile } from "common-components/Tile";
import { LandingPageTabs } from "common-components/LandingPageTabs";
import RectangleLoader from "common-components/RectangleLoader";
import YourRequestBanner from "./components/YourRequestBanner/YourRequestBanner";
// import FetchPageContent from "../../../hoc/FetchPageContent";
import "./LoggedInLanding.css";
import { history } from "../../Layout";

class LoggedInLanding extends Component {
  state = {
    loading: true
  };
  componentDidMount() {
    // const { pageContent } = this.props;
    this.props.fetchPageContent(ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE).then(() => {
    this.setState({ loading: false });
    if (checkNestedObject(this.props.pageContent, "sections", [2], "gnavDropdown")) {
      this.props.setBreadCrumbListInRedux({ gnavDropdown: this.props.pageContent.sections[2].gnavDropdown });
    }

    if (checkNestedObject(this.props.pageContent, "sections", [2], "breadCrumbs")) {
      this.props.setBreadCrumbListInRedux({ breadCrumbs: this.props.pageContent.sections[2].breadCrumbs });
      this.props.setBreadcrumbList([
        { label: this.props.pageContent.sections[2].breadCrumbs.landingPage, path: "/privacy/secure/your-data" }
      ]);
    }

    this.props.setA11yContent("landing page", this.props.pageContent.sc_pagetitle, this.props.pageContent.seo_description);

    // This resets the device selection screen to have no selected device by default
    this.props.selectDevice({ mtn: "" });
  });
  }

  componentWillUnmount() {
    this.props.setBreadcrumbList([]);
  }

  render() {
    if (this.state.loading) {
      return <RectangleLoader />;
    }
    const {
      sections: [
        [
          topOfPage,
          middleOfPage,
          controlsSection,
          bottomOfPage,
          {
            tileContent: [tileContent]
          },
          download_complete,
          download_pending,
          delete_pending,
          delete_complete,
          download_extension,
          suspended_no_email,
          suspended_pending_email,
          generic_error
        ],
        modalContent
      ],
      landing_page_tabs: [landing_page_tabs]
    } = this.props.pageContent;

    const appeal_pending = this.props.pageContent.sections[2]["appeal"][4];
    const correct_in_progress = this.props.pageContent.sections[2]["appeal"][4];
    const download_pending1 = this.props.pageContent.sections[2]["appeal"][4];
    const delete_pending1 = this.props.pageContent.sections[2]["appeal"][4];

    const bannerContent = {
      download_complete,
      download_pending,
      delete_pending,
      delete_complete,
      download_extension,
      suspended_no_email,
      suspended_pending_email,
      appeal_pending,
      correct_in_progress,
      generic_error
    };

    const { myvPrivacyPreferences, oneVZ, oneVZEnabled } = window.reactGlobals;
    const role = setCustomRole(this.props.suspendedReason);

    return (
      <Fragment>
        <YourRequestBanner bannerContent={bannerContent} />
        <Container style={{ marginTop: "0", paddingTop: "0" }}>
          <SubContainer>
            <LandingPageTabs landing_page_tabs={landing_page_tabs} />

            <H1>{convertStringToElements(topOfPage.section_title)}</H1>
            <HeaderDesc>{convertStringToElements(topOfPage.section_description)}</HeaderDesc>

            <H2>{convertStringToElements(middleOfPage.section_title)}</H2>
            {/* section_description not present in middleOfPage
            <P>{convertStringToElements(middleOfPage.section_description)}</P> */}

            <div style={{ maxWidth: "596px" }}>
              <Accordion
                topLevelCategories={middleOfPage.categories}
                subLevelCategories={this.props.extendedPreview}
                fetchExtendedPreview={this.props.fetchExtendedPreview}
                loading={this.props.loading}
                error={this.props.error}
              />


              <DownloadAndDelete downloadAndDeleteData={bottomOfPage} modalContent={modalContent} />

              <div style={{ margin: "48px 0" }}>
                <H2>{convertStringToElements(controlsSection.section_title)}</H2>
                {controlsSection.links.map(
                  (link, i) =>
                    link.role[role] === "true" && (
                      <div key={link.text} style={{ margin: "24px 0" }}>
                        {link.link ? (
                          <ListGroup
                          key={i}
                          topLine={false}
                          bottomLine={controlsSection.links && i !==  (controlsSection.links.length) - 2  ? true : false}
                          surface="light"
                          viewPort=""
                          >
                          { link.uniqueId === "privacy_settings"  ?
                              <ListGroupItem actionElement="icon"  onClick={()=> oneVZ === "Y" && oneVZEnabled === "Y" ? window.location.href = link.oneVZLink : window.location.href = myvPrivacyPreferences }  ariaLabel={link.text+link.desc} >
                                <ListGroupItemTitle  bold={false}>
                                  {link.text}
                                </ListGroupItemTitle>
                                <ListGroupItemSubtitle>
                                  {convertStringToElements(link.desc)}
                                </ListGroupItemSubtitle>
                              </ListGroupItem>
                              :
                              <ListGroupItem  actionElement="icon" onClick={()=> history.push(link.link)} ariaLabel={link.text+link.desc} >
                              <ListGroupItemTitle  bold={false}>
                                {link.text}
                              </ListGroupItemTitle>
                              <ListGroupItemSubtitle>
                                {convertStringToElements(link.desc)}
                              </ListGroupItemSubtitle>
                            </ListGroupItem>
                          }
                          </ListGroup>                                  
                            ) : (
                            <Bold>{link.text}</Bold>
                          )}                        
                       </div>
                    )
                )}
              </div>

            </div>

            <H2 style={{ margin: "64px 0 28px 0" }}>
              {convertStringToElements(tileContent.title)}
            </H2>
            <div style={{ display: "flex", gap:"24px", flexWrap: "wrap" }}>
              {tileContent.list.map(
                tile =>
                  tile.role[window.reactGlobals.customRole] === "true" && (
                    <Tilelet                         
                          href={tile.tileLink } 
                          title= {{                                   
                                    bold:true,
                                    size:"medium",
                                    children: tile.heading
                                }}
                                subtitle={{
                                  bold:false,
                                  children: tile.linkText,
                                  colour: 'primary'                                     
                                }}
                                directionalIcon={{                                      
                                  size: 'small',
                                }}
                                backgroundColor= 'gray'
                                tabIndex={0}                                
                                rowQuantity={{desktop: 2,mobile: 1}}
                                width= "596px"
                                height= "200px" 
                                aspectRatio="none"

                />   
                  )
              )}
            </div>           
          </SubContainer>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  userPreviewReducer: { extendedPreview, loading, error },
  downloadAndDelete: { suspendedReason },
  pageContent
}) => ({
  extendedPreview,
  loading,
  error,
  pageContent,
  suspendedReason
});

LoggedInLanding.propTypes = {
  fetchExtendedPreview: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  extendedPreview: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  suspendedReason: PropTypes.string
};

export default compose(
  connect(
    mapStateToProps,
    { fetchExtendedPreview, setA11yContent,fetchPageContent,selectDevice, setBreadcrumbList, setBreadCrumbListInRedux }
  ),
  // FetchPageContent
)(LoggedInLanding);

const Container = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  padding: 48px 0;

  ${media.mobile`
    margin: 25px auto;
    padding: 0;
  `};
`;

const SubContainer = styled.div`
  padding: 0 20px;

  ${media.mobile`
    padding: 0 16px;
  `};
`;

const P = styled.p`
  margin-bottom: 25px;
  ${media.mobile`
    margin-bottom: 22px;  
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    max-width: 296px;
  `};
`;


const HeaderDesc = styled.div`
  margin-bottom: 48px;

  p,
  a {
    max-width: 596px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
  };

  p:first-of-type {
    margin-bottom: 24px;
  }

  ul {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    line-height: 24px;

    li {
      font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
      list-style-position: outside;
    }
  }
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-style: normal;
  max-width: 565px;
  margin-top: 64px;
  margin-bottom: 32px;

  ${media.mobile`
   font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
   font-size: 32px;
   font-style: normal;
   font-weight: 400;
   line-height: 36px;
   margin-top: 40px;
  `};
`;

const H2 = styled.h2`
  margin-bottom: 20px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  span {
    height: 5px;
    display: block;
    width: 49px;
    background-color: #d52b1e;
    margin-top: 16px;
  }

  ${media.mobile`
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 24px;	
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 700;
    line-height: 28px;
	`};
`;

const Bold = styled.p`
  font-size: 18px;
  line-height: 19px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
`;

const Tile = styled(CommonTile)`
  flex-basis: 48%;  
  margin-right:24px;
 background-color:#F6F6F6;
  span.tile_desc{
  max-width:548px;
  font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  }

  span.tile_text{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700; 
    font-size: 20px;
    line-height: 24px;
    ${media.mobile`
    font-size: 16px;
  `}
}


  ${media.mobile`
    flex-basis: 100%;
    margin-right:0px;
    margin-bottom:12px;
  `}
`;

const ButtonDescription = styled.p`
  margin-top: 5px;
  max-width: 526px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  color:#6F7171;

  ${media.mobile`
    max-width: 296px;
    font-family: Verizon NHG eTX, Helvetica, Arial, sans-serif;;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  `};
`;